import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

/**
 * V2 Notification Store (Zustand)
 *
 * Stores full notification objects:
 * { id, message, message_type, entity_id, created_at }
 *
 * Persisted in localStorage as 'sb_notifications_v2'.
 */
const useNotificationStoreV2 = create(
  devtools(
    persist(
      (set) => ({
        notifications: [],

        addNotification: (notif) =>
          set((state) => {
            if (state.notifications.some((n) => n.id === notif.id)) return state;
            return { notifications: [notif, ...state.notifications] };
          }),

        clearAll: () => set({ notifications: [] }),

        removeById: (id) =>
          set((state) => ({ notifications: state.notifications.filter((n) => n.id !== id) })),

        // Replace entire list with what the DB returns (source of truth)
        setNotifications: (list) => set({ notifications: list }),

        // Prepend notifications not already in the list (e.g. ones missed while the stream was reconnecting)
        mergeNotifications: (list) =>
          set((state) => {
            const known = new Set(state.notifications.map((n) => n.id));
            const fresh = list.filter((n) => !known.has(n.id));
            if (!fresh.length) return state;
            return { notifications: [...fresh, ...state.notifications] };
          }),
      }),
      { name: 'Notifications Store' }
    )
  )
);

export default useNotificationStoreV2;
